export const homePage = {
    numberSte: '수량: <span class="color-green">{count}</span> NFT',
    title: 'AIS의 NFT 컬렉션',
    titleContent: 'INO 구매 조건:',
    lineContent1: '신원 확인하였습니다',
    lineContent2: '각 계정은 최대 1개의 남성용 셔츠와 1개의 여성용 셔츠를 구매할 수 있습니다',
    buttonBuy: '구매하기',
    soldOut: '품절',
    numberProducts: 'SL: <span class="color-red">{count}</span> NFT',
    noLoginTitle: '로그인하지 않았습니다.',
    contentNoLogin: 'NFT를 구매하려면 로그인해야 합니다.',
    buttonNoLogin: '로그인',
    buttonVerify: '신원확인하기',
    changePass: '비밀번호 변경하기',
    logOut: '로그아웃',
    ok: '확인',
    noVerifyTitle: '신원을 확인하지 않았습니다.',
    chooseWallet: '지갑을 선택하세요',
    notEnoughMoney: '잔액이 충분하지 않습니다.',
    confirmBuy: 'NFT 구매를 확인하기',
    price: '구매 가격',
    confirmBuyButton: '구매 확인',
    loginBuy: '구매하려면 로그인하세요',
    timeup: '판매가 종료되었습니다.',
    remain: '나머지: {remain}',
    confirmSellButton: '판매하기',
    titleConnectWallet: '지갑을 연결하세요',
    youNeedConnectMetamask: 'NFT를 구매하려면 지갑을 연결해야 합니다.',
    connectWallet: '지갑을 연결하기',
    noVerifyContent: 'NFT를 구매하려면 신원을 확인해야 합니다.',
    noVerifyButton: '확인하기',
    rejectVerifyTitle: '귀하의 계정이 확인 거부되었습니다',
    rejectVerifyContent: 'NFT를 구매하려면 재확인해야 합니다.',
    rejectVerifyButton: '재확인하기',
    pendingVerifyTitle: '계정이 확인 대기 중입니다.',
    penddingVerifyButton: 'Ok',

    approvedTitle: '판매예정',
    approvedSubTitle1: '판매를 개시할 시간:',
    approvedLine1: '2022/06/21일 08:00 UTC',
    approvedLine2: ' 2차: 70 NFT 여성용 트레이닝 셔츠는 2022/06/18일 15:00부터 판매 개시',
    approvedSubTitle2: '구매 조건',
    approvedLine3:
        '3차: 70 NFT 남성용 트레이닝 셔츠 및 30 NFT 여성용 트레이닝 셔츠는 2022/06/21일 15:00부터 판매 개시',
    approvedLine4: '총 NFT 남성용 셔츠는 100, 여성용 셔츠는 100',
    approvedLine5: '각 계정은 최대 1개의 남성용 셔츠와 1개의 여성용 셔츠를 구매할 수 있습니다.',
    approvedLine6: '계정에 등록되고 신원을 확인하였습니다.',
    approvedButton: 'Ok',

    connectPayButton: '지갑을 연결하기',
    pedding: '확인 대기 중',
    peddingTitle: '귀하의 계정이 확인 대기 중입니다.',
    successVerifyTitle: '귀하의 계정이 확인되었습니다.',
    successVerifyButton: 'Ok',
    message: {
        titleConnectWallet: '지갑을 연결하기.',
        deviceNotSupport: '장치가 지원되지 않습니다.',
        connectFail: '연결에 실패했습니다.',
        opened: '로그인 확인을 위해 메타마스크 창을 열어주세요.',
    },
    buttonRegister: '지금 등록하기',
    buttonTextVerify: '확인하기',
    newItemTitle: '새 제목',
    walletTitle: '지갑',
    walletBalance: '잔액',
    loadWallet: '로드',
    loadWalletTitle: '로드',
    loadWalletContent: 'BNB Smart Chain (BEP20)',
    loadWalletSubContent: 'AIS, SB, BNB, USDT를 정확한 지갑 주소로 보내주세요.',
    walletAddress: '지갑 주소',
    scanAddress: '지불을 받으려면 주소를 스캔하세요',
    withdrawWallet: '지갑을 인출하기',
    withdrawWalletTitle: 'STE 인출하기',
    commonSoon: '출시 예정',
    okie: 'Ok',
    copyAddress: '지갑 주소가 복사됩니다.',
    productTitle: 'AIS의 NFT 컬렉션',
    remainTimeBuy: '남은 판매 시간: ',
    bannerTitle: '최고의 프리미엄, 독특하고 독점적인 NFT 컬렉션을 발견하십시오',
    line1: '2022/06/21일 08:00 UTC',
    line2: '2차: 70 NFT 여성용 트레이닝 셔츠는 2022/06/18일 15:00부터 판매 개시',
    bannerSubTitle: '구매 조건',
    line3: '3차: 70 NFT 남성용 트레이닝 셔츠 및 30 NFT 여성용 트레이닝 셔츠는 2022/06/21일 15:00부터 판매 개시',
    line4: '총 NFT 남성용 셔츠는 100, 여성용 셔츠는 100',
    line5: '각 계정은 최대 1개의 남성용 셔츠와 1개의 여성용 셔츠를 구매할 수 있습니다.',
    line6: '계정에 등록되고 신원을 확인하였습니다.',
    haveOwned: '소유하였습니다.',
    modalFire: {
        title: '축하합니다!',
        subTitle: 'INO STE 계단 <span>{count}</span> 종료하였습니다.',
        content1: 'NFT STE를 성공적으로 소유한 회원 여러분 축하합니다.',
        content2:
            ' 이번에 운이 없다면 <span>{count}</span> 15:00(VN)에 참여하세요.',
        stage1: ' 다음 6월 18일',
        stage2: ' 다음 6월 21일',
    },
    coming_soon: '출시 예정',
    download: '다운로드',


    filter_order: '필터 순서',
    filter_nft: 'NFT 유형별 필터',
    filter_mint: '민트 개수별 필터',
    filter_token: '토큰 유형 필터',
    newest: '최신',
    price_asc: '가격: 낮은 가격에서 높은 가격 ↑',
    price_desc: '가격: 높은 가격에서 낮은 가격 ↓',
    all: '모두',
    nft_m: 'NFT M',
    nft_w: 'NFT W',
    nft_s: 'NFT S',
    nft_us: 'NFT US',
    nft_os: 'NFT OS',
    mint_couple: '민트 커플',
    last1: '1번 남음',
    last2: '2번 남음',
    last3: '3번 남음',
    last4: '4번 남음',
    last5: '5번 남음',
    last6: '6번 남음',
    last7: '7번 남음',
    new: '신규',
    expire: '만료',
    cancel_sell: '판매 취소',
    confirm_cancel: 'NFT 판매 취소',
    price_sell: '판매 가격:',
    fee: '판매 수수료 5%:',
    ste_receive: ' {0} 받게됨:',
    couple_des: '민트 NFT는 커플(NFT M 및 NFT W)으로 거래되어야 합니다.',
    invite: '친구추천하기',
    invite_title: '친구초대하기',
    rule: '규칙',
    rule1: '계정이 없는 친구에게 귀하의 추천/제휴 ID를 공유합니다',
    rule2: '추천받는 자는 성공적으로 신원을 확인하고 운동에 참여해야 합니다.',
    rule3: '추천에 성공할 때마다 4일의 무료 플레이가 추가로 제공됩니다.',
    id_invite: '귀하의 추천 ID',
    linkref: '초대링크',
    ref_code: '추천 코드',
    copy_success: '복사가 성공하였습니다!',
    condition_sell: 'NFT 판매 조건',
    condition_sell1: '1. NFT는 새 제품(미사용)입니다.',
    condition_sell2: '2. 사용한 NFT는 보상을 7회 이상 받아야 합니다. (보상을 받은 횟수가 7회 미만인 NFT는 판매할 수 없음)',
    condition_sell3: '3. 민트 NFT는 커플(NFT M 및 NFT W)으로 거래되어야 합니다.',
    condition_sell4: '4. 사용하고 판매 게시 시 7회 이상 보상을 받은 NFT는 만료일까지 계속 카운트됩니다. 누군가 구매하면 만료 날짜가 자동으로 만료됩니다. 판매자가 판매를 취소하면 만료 날짜는 계산된 일수와 같습니다.\n',
    condition_sell5: '5. 판매하고 있는 NFT는 운동용으로 사용할 수 없습니다.\n',
    condition_sell6: '6. 사용된 NFT에는 민트가 있어야 합니다.',
    nft_not_mint: 'NFT는 아직 민트가 아닙니다',
    sell: '판매',
    confirm_sell: 'NFT 판매 확인',
    transfer_confirm: 'NFT 이전 확인',
    fee_transfer: '이전 수수료:',
    sell_placeholder: '판매가격을 입력하기',
    valid_price: '판매가격을 입력해주세요',
    priceSellRequired: '판매가격을 입력해주세요',
    confirm_text: '확인',
    change_price: '가격 변경',
    change_price_title: 'NFT 판매 가격 변경',
    sell_success: 'NFT 판매 가격 게시가 성공하였습니다!',
    nft_minted: '민트된 NFT',
    history_title: '내역',
    history_text: '거래 내역',
    nft_transaction: 'NFT 거래',
    ste_transaction: 'STE 거래 내역',
    stt: '순번',
    time: '시간',
    type_transaction: '거래 유형',
    type_nft: 'NFT 유형',
    id_nft: 'ID NFT',
    price_nft: '가격',
    transfer_nft: '보낸 자 / 받은 자',
    fee_nft: '요금',
    type_wallet: '지갑 유형',
    total: '금액',
    hash: 'Hash',
    wallet_to: '받는 지갑 주소',
    status: '상태',
    copySuccess: '복사가 성공하였습니다',
    copyFail: '복사가 실패하였습니다',
    not_available: 'NFT가 판매되었거나 사용할 수 없음!',
    transfer: "이전",
    collaborators_title: "협력자"
};
